import React from 'react';
import InputMask from 'react-input-mask-next';
import { useFormContext, Controller } from 'react-hook-form';

interface MaskedInputProps {
  name: string;
  label: string;
  mask: string;
  required?: boolean;
  placeholder?: string;
}

export default function MaskedInput({ name, label, mask, required, placeholder }: MaskedInputProps) {
  const { control, formState: { errors } } = useFormContext();

  const error = name.split('.').reduce((obj: any, key) => obj?.[key], errors);
  const errorMsg = error?.message as string | undefined;

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputMask mask={mask} value={field.value || ''} onChange={field.onChange} onBlur={field.onBlur}>
            <input
              placeholder={placeholder}
              className={`ant-input w-full px-3 py-1 border rounded ${errorMsg ? 'border-red-500' : 'border-gray-300'}`}
            />
          </InputMask>
        )}
      />
      {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
    </div>
  );
}
